const problems = [
  {
    icon: 'ri-emotion-unhappy-line',
    title: 'Конфликты',
    desc: 'Межличностные и межотделенческие конфликты отнимают энергию, замедляют работу и создают токсичную атмосферу.',
  },
  {
    icon: 'ri-shield-cross-line',
    title: 'Отсутствие доверия',
    desc: 'Сотрудники скрывают ошибки, не делятся идеями и опасаются быть открытыми. Доверие — фундамент команды.',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Изолированные отделы',
    desc: 'Отделы работают как отдельные компании: информация не передается, цели не совпадают, результаты страдают.',
  },
  {
    icon: 'ri-chat-off-line',
    title: 'Слабая коммуникация',
    desc: 'Непонятно, кто за что отвечает. Решения принимаются в узком кругу. Обратная связь отсутствует или искажается.',
  },
  {
    icon: 'ri-eye-off-line',
    title: 'Низкая вовлеченность',
    desc: 'Сотрудники не предлагают улучшений, не берут инициативу и работают «от звонка до звонка».',
  },
  {
    icon: 'ri-user-unfollow-line',
    title: 'Высокая текучесть',
    desc: 'Люди уходят не из-за зарплаты, а из-за плохой атмосферы, отсутствия развития и некомфортных отношений.',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: 'Отсутствие инициативы',
    desc: 'Команда ждет указаний сверху. Никто не берет на себя ответственность за улучшения и инновации.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Нежелание брать ответственность',
    desc: 'Задачи перекладываются, решения откладываются, проблемы обрастают «это не моя зона ответственности».',
  },
  {
    icon: 'ri-lock-line',
    title: 'Сопротивление изменениям',
    desc: 'Любые нововведения встречают саботаж. Команда привыкла к статус-кво и боится перемен.',
  },
  {
    icon: 'ri-emotion-sad-line',
    title: 'Плохая атмосфера',
    desc: 'В офисе царит напряжение, страх, пессимизм. Люди не хотят приходить на работу.',
  },
  {
    icon: 'ri-group-line',
    title: 'Разделение «мы» и «они»',
    desc: '«Наш отдел» против «их отдела». Внутри компании формируются враждующие лагеря.',
  },
  {
    icon: 'ri-user-settings-line',
    title: 'Недоверие руководителю',
    desc: 'Сотрудники не верят словам руководства, не разделяют визию и не готовы следовать за лидером.',
  },
];

export default function ProblemsSolved() {
  return (
    <section id="problems" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Какие проблемы решает командообразование
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Многие проблемы в компании — это не проблемы отдельных людей, а проблемы взаимодействия. Командообразование работает именно с этим.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {problems.map((p, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 hover:bg-gray-100 transition-colors group border border-gray-100">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${p.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{p.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}